import React, { Component } from "react";
import CarouselSectionSwitcher from './carousel-section-switcher.jsx';
import Blog from './blog-item.jsx';
import { getArticles } from '../../apis/inspiration';

class RelatedBlogsSection extends Component {
    constructor(props) {
        super(props);

        this.state = {
            items: [],
            isLoading: true
        };
    }

    componentDidMount() {
        this.ajaxPromise = getArticles({
            page: 1,
            pageSize: 3,
            tag: this.props.tags.map(tag => tag.Id).join(';')
        });

        this.ajaxPromise.then(data => {
                this.setState({
                    items: data.records,
                    isLoading: false
                });
            })
            .catch(error => {
                console.log(error);
                if (error.name === 'AbortError') return;
                this.setState({
                    isLoading: false
                });
            });
    }

    componentWillUnmount() {
        this.ajaxPromise.controller.abort();
    }

    render() {
        if (this.state.items.length || this.state.isLoading) {
            const carouselItems = this.state.items.map((blog, index) => (
                <Blog key={index} {...blog} />
            ));
            const sectionItems = <div className="row">
                {this.state.items.map((blog, index) => (
                    <Blog key={index} {...blog} />
                ))}
            </div>;

            return (
                <CarouselSectionSwitcher switchWidth={575} titleBold={this.props.titleBold} carousel={carouselItems} section={sectionItems} />
            );
        }

        return null;
    }
}

export default RelatedBlogsSection;